<template>
    <el-dialog title="图片剪裁" :visible.sync="open" append-to-body :before-close="openClose">
        <div class="cropper-content">
            <div class="cropper" :style="scrollHeight">
                <vueCropper
                    ref="cropper"
                    :img="option.img"
                    :outputSize="option.size"
                    :outputType="option.outputType"
                    :fixedNumber="option.fixedNumber"
                    :fixed="option.fixed"
                    :info="true"
                    :full="option.full"
                    :canScale="option.canScale"
                    :centerBox="true"
                    :canMove="option.canMove"
                    :enlarge="option.enlarge"
                    :maxImgSize="option.maxImgSize"
                    :canMoveBox="option.canMoveBox"
                    :autoCrop="option.autoCrop"
                    :autoCropWidth="option.autoCropWidth"
                    :autoCropHeight="option.autoCropHeight"
                >
                </vueCropper>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="openClose">取 消</el-button>
            <el-button type="primary" @click="saveImg">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { VueCropper } from 'vue-cropper'
import { uploadFile } from '@/api/file'

export default {
    name: 'Cropper',
    components: {
        VueCropper
    },
    computed: {
        scrollHeight() {
            return "height:" + '400' + "px";
        }
    },
    props: {
        cropperImg: {
            type: String,
            default: ''
        },
        shenbaoId: {
            type: Number,
            default: 0,
            required: true
        }
    },
    data() {
        return {
            open: false,
            crap: false,
            previews: {},
            option: {
                img: '',
                size: 1,
                full: false,
                outputType: 'png',
                fixed: true,
                fixedNumber: [3, 1],
                canMove: false,
                canMoveBox: true,
                autoCrop: true,
                autoCropWidth: 1920,
                autoCropHeight: 640,
                maxImgSize: 3000,
                enlarge: 2,
                canScale: false,
                downImg: '#',
            }
        };
    },
    watch: {
        cropperImg: {
            immediate: true,
            handler: function (newVal) {
                if (newVal) {
                    this.option.img = newVal
                    this.open = true
                }
            }
        }
    },
    methods: {
        openClose(){
            this.$emit('uploadImg','close')
            this.open = false
        },
        uploadFile(files) {
            // 申报网页banner背景
            uploadFile(files, `shenbao/${this.shenbaoId}/page/bg/`).then(res => {
                this.$emit('uploadImg',res)
                this.open = false
            })
        },
        saveImg() {
            this.$refs.cropper.getCropBlob(data => {
                let files = new window.File([data], 'test.png', {type: 'image.png'})
                this.uploadFile(files)
            });
        }
    }
}
</script>
